module.exports = __webpack_public_path__ + "static/media/Hospitality_31.27cc2477.jpg";